import { twc } from 'util/cn'

export const ButtonGroup = twc.div`flex flex-col space-y-[12px] pt-[8px]`
